import { useState, useEffect, useCallback } from "react";
import { fetchAndActivate, getValue } from "firebase/remote-config";
import { remoteConfig } from "../firebase/firebase";

export interface UseSourceDestinationEnabledReturn {
  isSourceDestinationEnabled: boolean;
  isLoadingSourceDestinationFlag: boolean;
}

export const useSourceDestinationEnabled =
  (): UseSourceDestinationEnabledReturn => {
    const [isEnabled, setIsEnabled] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);

    const fetchRemoteConfig = useCallback(async () => {
      try {
        setLoading(true);
        await fetchAndActivate(remoteConfig);
        const enabled = getValue(
          remoteConfig,
          "source_destination_feature_enabled"
        ).asBoolean();
        setIsEnabled(enabled);
      } catch (error) {
        console.error(
          "Error fetching source_destination_feature_enabled config:",
          error
        );
        setIsEnabled(false);
      } finally {
        setLoading(false);
      }
    }, []);

    useEffect(() => {
      fetchRemoteConfig();
    }, [fetchRemoteConfig]);

    return {
      isSourceDestinationEnabled: isEnabled,
      isLoadingSourceDestinationFlag: loading,
    };
  };
